import { Component, ViewChild } from '@angular/core';
import { NavigationViewModel } from './NavigationViewModel';
import { NavigationMenuModel } from 'projects/core/src/lib/core/model/NavigationMenuModel';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { IonTabBar, AlertController, LoadingController, Platform, ModalController } from '@ionic/angular';
import { HelperMenuContrato } from 'projects/core/src/lib/core/HelperMenuContrato';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { BasePage } from '../base.page';
import { Router } from '@angular/router';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { MessageService } from 'projects/core/src/lib/core/MessageService';
import { NotificacoesModel } from 'projects/core/src/lib/core/model/NotificacoesModel';
import { PlanoDialog } from '../plano/plano.dialog';
import { NavegaTelaPlanoImpl } from '../plano-ios/NavegaTelaPlanoImpl';
import { FirebaseWrapper } from 'projects/core/src/lib/core/FirebaseWrapper';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { PushNotifications } from '@capacitor/push-notifications';

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.html',
  styleUrls: ['navigation.scss']
})
export class Navigation extends BasePage implements NavegaTelaPlanoImpl {

  @ViewChild(IonTabBar) tabbar: IonTabBar;

  quantidadeNotificacoesRecomendacoes: number = 0
  navigationViewModel: NavigationViewModel
  menu: Array<NavigationMenuModel>
  contratoWrapper: ContratoWrapperModel
  alertComponent: AlertComponent
  aberturaPagina: boolean = true
  loadingComponent: LoadingComponent
  resetStackTabs = ['carteira-recomendada', 'recomendacoes'];

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    public alertController: AlertController,
    private loadingController: LoadingController,
    public router: Router,
    private platform: Platform,
    private modalCtrl: ModalController
  ) {
    super(router)
  }

  handleTabClick = (event: MouseEvent) => {
    const { tab } = event.composedPath().find((element: any) =>
      element.tagName === 'ION-TAB-BUTTON') as EventTarget & { tab: string };

    if (this.resetStackTabs.includes(tab)) {
      this.router.navigate(['/navigation/' + tab]);
    }
  };

  async changeTab(event) {
    if(event.tab==='recomendacoes-opcoes')
      return;
    this.googleAnalyticsService
      .logEvent(`acesso_${event.tab}`, {
        acesso_de: 'tab'
      })
    await this.buscaContratos()
    let item: NavigationMenuModel = this.getItemMenuPorTab(event.tab)
    if (item.chaveContrato.indexOf(ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES) < 0 &&
      item.chaveContrato.indexOf(ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS) < 0) {
      if (!await HelperMenuContrato.validaMenu(item)) {
        this.openPage('/navigation/home')
      }
    }
    //this.buscaQuantidadeNotificacoes()
  }

  async ngOnInit() {
    this.inicializarVariaveis()
    this.initObservable()
    await this.buscaMenuNavigation()
    await this.buscaContratos()

    await this.obtemOpcoesNotificacao()

    this.platform.ready().then(() => {
      this.handlerPushNotification()
      this.processoTokenFirebase()
    })
  }

  inicializarVariaveis() {
    this.navigationViewModel = new NavigationViewModel()
    this.navigationViewModel.setContext(this)
    this.loadingComponent = new LoadingComponent(this.loadingController)
  }

  initObservable() {
    MessageService.getMessage().subscribe(async message => {
      if (message && message.identifyObservable == MessageService.KEY_LOGIN) {
        await this.buscaContratos()
      }
    })
  }

  async buscaContratos() {
    try {
      if (await this.navigationViewModel.userAuthenticate()) {
        await this.navigationViewModel.apiBuscaContratos()
      }
    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, e.message)
    }
  }

  async navegaTelaPlano(urlContratar) {
    const modalBoasVindas = await this.modalCtrl.create({
      component: PlanoDialog,
      componentProps: {
        urlContratar
      }
    });
    modalBoasVindas.present();
  }

  async obtemOpcoesNotificacao() {
    try {
      await this.navigationViewModel.obtemOpcoesNotificacao()
    } catch (e) {

    }
  }

  setOpcoesNotificacoes(notificacoesModel: NotificacoesModel) {
    this.navigationViewModel.configuraTopicsFirebase(notificacoesModel)
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  showAlert(title: string, message: string) {
    AlertComponent.showAlert(title, message)
  }

  async buscaMenuNavigation() {
    this.menu = NavigationMenuModel.getNavigationMenu()
    //this.processaBadge()
    //this.tabbar.selectedTab = 'home'
  }

  getItemMenuPorTab(tab: string) {
    for (let i in this.menu) {
      if (this.menu[i].tab == tab) {
        return this.menu[i]
      }
    }
    return null
  }

  processaBadge() {
    this.menu.forEach(async (value) => {
      if (value.chaveContrato.indexOf(ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES) >= 0) {
        value.countBadge = await this.buscaQuantidadeNotificacoes();
      }
    })
  }

  async buscaQuantidadeNotificacoes(): Promise<number> {
    return await this.navigationViewModel.getContadorNotificacoes()
  }

  setListaContratos(contratoWrapper: ContratoWrapperModel) {
    this.contratoWrapper = contratoWrapper
  }

  configuraTopicsFirebase(notificacoesModel: NotificacoesModel) {

  }

  handlerPushNotification() {
    this.navigationViewModel.handlerPushNotification()
  }

  async processoTokenFirebase() {
    PushNotifications.addListener("registration", async () => {
      const token = await new FirebaseWrapper().getToken()
      this.enviaTokenApi(token.token)
    });
  }

  enviaTokenApi(fcmToken) {
    try {
      this.navigationViewModel.salvaTokenApi(fcmToken)
    } catch (e) { }
  }
}
